import { FormField, WithFormField } from '@shared/forms/components/FormField';

import { CheckboxInput, CheckboxInputProps } from './CheckboxInput';

export function CheckboxField({ name, label, required, ...props }: WithFormField<CheckboxInputProps>) {
  return (
    <FormField
      name={name}
      label={label}
      required={required}
      className="grid-cols-[max-content_auto]"
      labelClassName="order-2"
    >
      {(field) => <CheckboxInput {...field} {...props} className="order-1" />}
    </FormField>
  );
}
